import { FuseNavigation } from '@fuse/types';
// roles: "PresupuestoApi_GestionVigenciaFiscal",
export const navigation: FuseNavigation[] = [
    {
        id: 'Autenticacion',
        title: 'Autenticación',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'login',
                title: 'Iniciar Sesión',
                type: 'item',
                icon: 'lock',
                url: '/login'
            },
        ]
    },
    {
        id: 'ArchivoInventario',
        title: 'Inventario de Archivos',
        type: 'group',
        icon: 'book',
        children: [
            {
                id: 'archivo',
                title: 'Archivo',
                type: 'collapsable',
                icon: 'apps',
                children: [
                    {
                        id: 'inventario',
                        title: 'Inventario',
                        type: 'item',
                        icon: 'calendar_today',
                        url: '/archivo/inventario',
                        roles: 'ArchivoInventarioApi_Archivo'
                    },
                    {
                        id: 'caja',
                        title: 'Cajas',
                        type: 'item',
                        icon: 'calendar_today',
                        url: '/archivo/caja',
                        roles: 'ArchivoInventarioApi_Archivo'
                    },
                ]
            },
            {
                id: 'DatosBasicos',
                title: 'Datos básicos',
                type: 'collapsable',
                icon: 'apps',
                children: [
                    {
                        id: 'Vigencia Fiscal',
                        title: 'Vigencia Fiscal',
                        type: 'item',
                        icon: 'calendar_today',
                        url: '/datos-basicos/vigencia-fiscal',
                        roles: 'ArchivoInventarioApi_DatosBasicos'
                    },
                    {
                        id: 'Seccion',
                        title: 'Sección',
                        type: 'item',
                        icon: 'list',
                        url: '/datos-basicos/seccion',
                        roles: 'ArchivoInventarioApi_DatosBasicos'
                    },
                    {
                        id: 'Serie',
                        title: 'Serie',
                        type: 'item',
                        icon: 'list',
                        url: '/datos-basicos/serie',
                        roles: 'ArchivoInventarioApi_DatosBasicos'
                    }
                ]
            },
           
        ]
    }
];
